"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExceptionInfo = getExceptionInfo;
exports.applyFormikFieldErrors = applyFormikFieldErrors;
exports.redirectWithContext = redirectWithContext;
exports.removeFields = removeFields;
exports.friendlyLabel = friendlyLabel;
exports.getVersionLabel = getVersionLabel;
exports.getOptionsFromList = getOptionsFromList;
exports.staticAssetUrl = staticAssetUrl;
exports.friendlyKeyToLabel = friendlyKeyToLabel;
exports.replaceDynamicPaths = replaceDynamicPaths;
exports.getSingularOrPlural = getSingularOrPlural;
exports.error = error;
exports.throwError = throwError;
exports.fromCamelCaseToSentence = fromCamelCaseToSentence;
exports.getKeyByValue = getKeyByValue;
exports.loadScript = exports.debug = exports.getYears = exports.getCurrentYear = exports.getLastMonthNumber = exports.getLastMonthIndex = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _capitalize = _interopRequireDefault(require("lodash/capitalize"));

var _config = _interopRequireDefault(require("next/config"));

var _router = _interopRequireDefault(require("next/router"));

var _captureException = require("./captureException");

var _date = require("./date");

/**
 * Extract message and errors from exception object
 * Most commonly used when handling an exception thrown from an axios request
 *
 * @param {Error} exception
 * @returns {Object} message and errors present in the exception
 */
function getExceptionInfo(exception) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$defaultMessage = _ref.defaultMessage,
      defaultMessage = _ref$defaultMessage === void 0 ? 'Something went wrong' : _ref$defaultMessage;

  var _ref2 = ((exception === null || exception === void 0 ? void 0 : exception.response) || {}).data || {},
      _ref2$message = _ref2.message,
      message = _ref2$message === void 0 ? defaultMessage : _ref2$message,
      _ref2$errors = _ref2.errors,
      errors = _ref2$errors === void 0 ? {} : _ref2$errors;

  return {
    message: message,
    errors: errors
  };
}
/**
 * Pushes API errors to formik form
 *
 * @param {Object} errors - Errors object as coming from an API request
 * @param {Function} setFieldError - formikBag setFieldError function
 */


function applyFormikFieldErrors(errors, setFieldError) {
  Object.entries(errors).forEach(function (_ref3) {
    var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
        fieldName = _ref4[0],
        fieldErrorsList = _ref4[1];

    setFieldError(fieldName, fieldErrorsList[fieldErrorsList.length - 1]);
  });
}

function redirectWithContext(context, toPath) {
  var permanent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  // For server
  if (context && context.res) {
    var redirectType = permanent ? 301 : 302;
    context.res.writeHead(redirectType, {
      Location: toPath
    });
    context.res.end("Redirecting to ".concat(toPath, "\u2026"));
  } else {
    // For browser
    _router["default"].push(toPath);
  }
}
/**
 * We have some use cases where we need to hide some properties from the API response to not be
 * rendered in HTML.
 *
 * This function will filter an object with key values from the keys provided as parameters
 * @param {Object} contentList content object to be rendered on the page
 * @param {Array} keys list of keys to be filtered from the main list
 */


function removeFields(contentList, keys) {
  return Object.fromEntries(Object.entries(contentList).filter(function (_ref5) {
    var _ref6 = (0, _slicedToArray2["default"])(_ref5, 1),
        key = _ref6[0];

    return !keys.includes(key);
  }));
}
/**
 * Verify if the parameter is null to return a predefined friendly label instead.
 * If the parameter is an object, it should not return itselft because React does not render objects
 * @param {string} property property to be verified if is not null
 */


function friendlyLabel(property) {
  if (property === undefined || property === null || property === '') {
    return '—';
  }

  return property;
}
/**
 * Return a formatted string of the version of the file
 * @param {string} version document version
 */


function getVersionLabel(version) {
  return version ? "[V".concat(version, "]") : '';
}
/**
 * Normalize list of items as options to a select element
 * @param {Array} list
 */


function getOptionsFromList(list) {
  return (list || []).map(function (item) {
    return {
      value: item.slug,
      label: item.name
    };
  });
}
/**
 * Generates static asset url including ASSET_PREFIX if exists
 * @param {String} staticAssetPath
 */


function staticAssetUrl(staticAssetPath) {
  var _ref7 = (0, _config["default"])() || {},
      _ref7$publicRuntimeCo = _ref7.publicRuntimeConfig.ASSET_PREFIX,
      ASSET_PREFIX = _ref7$publicRuntimeCo === void 0 ? '' : _ref7$publicRuntimeCo;

  return "".concat(ASSET_PREFIX).concat(staticAssetPath);
}
/**
 * Format key to label
 *
 * Transforms a key into a friendly label
 * @param {String} key A string in kebab-case or snake_case
 * @example hello-world -> Hello World
 *  * @example hello_world -> Hello World
 */


function friendlyKeyToLabel() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (0, _capitalize["default"])(key.replace(/[_-]/g, ' '));
}

function replaceDynamicPaths(str, map) {
  return str.replace(/\[.*?\]/g, function (matched) {
    return map[matched];
  });
}

var getLastMonthIndex = function getLastMonthIndex() {
  var numberOfMonthsByIndex = 11;
  var currentMonthIndex = new Date().getUTCMonth();
  return currentMonthIndex <= 0 ? numberOfMonthsByIndex : currentMonthIndex - 1;
};

exports.getLastMonthIndex = getLastMonthIndex;

var getLastMonthNumber = function getLastMonthNumber() {
  return getLastMonthIndex() + 1;
};

exports.getLastMonthNumber = getLastMonthNumber;

var getCurrentYear = function getCurrentYear() {
  return new Date().getFullYear();
};

exports.getCurrentYear = getCurrentYear;

var getYears = function getYears() {
  return (0, _date.getYearOptions)({
    includeBlankOption: false
  });
};
/**
 * Returns a given singular word if the value is 1 (or -1)
 * or returns a given plural word otherwise
 * @param {Number || String} value
 * @param {String} singular option
 * @param {String} plural option
 * @returns {string} that matches the number of the value
 */


exports.getYears = getYears;

function getSingularOrPlural(value, singular, plural) {
  if (value == null || !singular || !plural) {
    return '';
  }

  var number = parseFloat(value);
  return number === 1 || number === -1 ? singular : plural;
}
/**
 * console.log only in development
 */


function logIfDev() {
  var log = function log() {};

  if (console && process.env.NODE_ENV === 'development') {
    /* eslint-disable no-console */
    log = console.log.bind(console);
    /* eslint-enable no-console */
  }

  return log;
}

var debug = logIfDev();
/**
 * throw error on development
 * or capture the exception on sentry if on a live env
 */

exports.debug = debug;

function error(message) {
  var NODE_ENV = process.env.NODE_ENV;

  if (NODE_ENV === 'development' || NODE_ENV === 'test') {
    throw new Error(message);
  }

  (0, _captureException.captureException)(message);
}

function throwError(expection) {
  var NODE_ENV = process.env.NODE_ENV;

  if (NODE_ENV === 'production') {
    (0, _captureException.captureException)(expection);
  }

  throw expection;
}

function fromCamelCaseToSentence(word) {
  return word.replace(/([A-Z][a-z]+)/g, ' $1').replace(/([A-Z]{2,})/g, ' $1').replace(/\s{2,}/g, ' ').trim();
}
/**
 * loads a script dynamically
 */


var loadScript = function loadScript(_ref8) {
  var scriptId = _ref8.scriptId,
      scriptSrc = _ref8.scriptSrc,
      callback = _ref8.callback;
  var existingScript = document.getElementById(scriptId);

  if (!existingScript) {
    var script = document.createElement('script');
    script.src = scriptSrc;
    script.id = scriptId;
    document.body.appendChild(script);

    script.onload = function () {
      if (callback) callback();
    };
  }

  if (existingScript && callback) callback();
};

exports.loadScript = loadScript;

function getKeyByValue(object, value) {
  return Object.keys(object).find(function (key) {
    return object[key] === value;
  });
}